import React from 'react'
import { Link } from 'react-router-dom'
import { ButtonBase } from '@mui/material'
import config from './../../config/config'
import logo from './../../assets/images/logo.png'
const LogoSection = () => (
  <ButtonBase disableRipple component={Link} to={config.defaultPath}>
    <img src={logo} alt="" className="img-height-70" />
  </ButtonBase>
)

export default LogoSection
